var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33317 1.33812L6.66174 0.666687L3.99984 3.32859L1.33793 0.666687L0.666504 1.33812L3.32841 4.00002L0.666504 6.66192L1.33793 7.33335L3.99984 4.67145L6.66174 7.33335L7.33317 6.66192L4.67126 4.00002L7.33317 1.33812Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel8);
export default __webpack_public_path__ + "97120/static/media/cancel8.e2b4f4ec4ce3ec7af3aa123f2f421024.svg";
export { ForwardRef as ReactComponent };